export default "__VITE_ASSET__65abc9bd__"